export default __webpack_public_path__ + "static/media/report.0bbc7fe0.svg";